import { render, staticRenderFns } from "./Stagger.vue?vue&type=template&id=2f5b1ac4&scoped=true&"
import script from "./Stagger.vue?vue&type=script&lang=js&"
export * from "./Stagger.vue?vue&type=script&lang=js&"
import style0 from "./Stagger.vue?vue&type=style&index=0&id=2f5b1ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b1ac4",
  null
  
)

export default component.exports